import { memo, ReactNode } from "react";
import { Flex } from "../flex";
import * as css from "./system-message.module.css";

export const SystemMessage = memo(function SystemMessage({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Flex align="center" dir="row" gap="lg" w="full">
      <hr className={css.divider} />
      <Flex
        className={css.systemMessage}
        dir="row"
        justify="center"
        textAlign="center"
      >
        {children}
      </Flex>
      <hr className={css.divider} />
    </Flex>
  );
});
